export const InvoiceStatus = {
  Pending: 1,
  Processing: 2,
  Paid: 3,
  Failed: 4,
  Cancelled: 5,
};
